export default "__VITE_ASSET__BmUcOK_2__"